import { render, staticRenderFns } from "./resumeDetail.vue?vue&type=template&id=9c908cec&scoped=true&"
import script from "./resumeDetail.vue?vue&type=script&lang=js&"
export * from "./resumeDetail.vue?vue&type=script&lang=js&"
import style0 from "./resumeDetail.vue?vue&type=style&index=0&id=9c908cec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c908cec",
  null
  
)

export default component.exports